const isFirstRender = (): boolean => {
  const storedValue = sessionStorage.getItem('isFirstRender');
  return storedValue ? JSON.parse(storedValue) : true;
};

const setIsFirstRender = (value: boolean) => {
  sessionStorage.setItem('isFirstRender', JSON.stringify(value));
};

export const useIsFirstAppRender = () => ({ isFirstRender, setIsFirstRender });
